"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enforceDatabaseTypes = void 0;
const __1 = require("..");
// Enforced our collection interactions to follow the types defined in our models
function enforceDatabaseTypes(databases) {
    return __awaiter(this, void 0, void 0, function* () {
        // Construct the property validation on the fly
        const validateProperty = (property, type, required = true) => ({
            bsonType: type,
            description: `${property} must be a ${type} ${required ? 'and is required' : ''}`,
        });
        // Get all our properties from our models using static methods
        // For additional details: https://docs.mongodb.com/manual/core/schema-validation/
        // To see how to identify types: https://docs.mongodb.com/manual/reference/bson-types/
        const modelValidationMap = {
            globals: __1.Global.getValidationMap(),
            ipfs: __1.Ipfs.getValidationMap(),
            passports: __1.Passport.getValidationMap(),
            score_statistics: __1.ScoreStatistics.getValidationMap(),
            scores: __1.Score.getValidationMap(),
            skins: __1.Skin.getValidationMap(),
        };
        for (const db of databases) {
            for (const collection in modelValidationMap) {
                const collectionValidation = modelValidationMap[collection];
                const propertyList = Object.keys(collectionValidation);
                const propertyValidationMap = {};
                propertyList.forEach((property) => {
                    propertyValidationMap[property] = validateProperty(property, collectionValidation[property]);
                });
                // Reset everytime
                yield db.command({
                    collMod: collection,
                    validator: {},
                    validationLevel: 'off',
                });
                yield db.command({
                    collMod: collection,
                    validator: {
                        $jsonSchema: {
                            bsonType: 'object',
                            required: propertyList,
                            properties: propertyValidationMap,
                            additionalProperties: true,
                        },
                        validationLevel: 'strict',
                        validationAction: 'error', // 'error' or 'warn'
                    },
                });
            }
        }
    });
}
exports.enforceDatabaseTypes = enforceDatabaseTypes;
//# sourceMappingURL=validate.js.map